import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { confirmLeaveIfPending } from '../utils/pendingSave';

export function NavBar() {
  const { t, i18n } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const guardClick = (e: React.MouseEvent) => {
    if (!confirmLeaveIfPending(t('common.leaveWithPendingSave') as string)) e.preventDefault();
  };

  return (
    <header className="navbar">
      <div className="navbar-links">
        <strong>{t('app.title')}</strong>
        <NavLink to="/" end onClick={guardClick} className={({ isActive }) => (isActive ? 'active' : '')}>
          {t('nav.folders')}
        </NavLink>
        {user?.globalRole === 'ADMIN' && (
          <NavLink to="/admin/users" onClick={guardClick} className={({ isActive }) => (isActive ? 'active' : '')}>
            {t('nav.admin')}
          </NavLink>
        )}
        <NavLink to="/logos" onClick={guardClick} className={({ isActive }) => (isActive ? 'active' : '')}>
          {t('nav.logos')}
        </NavLink>
        <NavLink to="/settings" onClick={guardClick} className={({ isActive }) => (isActive ? 'active' : '')}>
          {t('nav.settings')}
        </NavLink>
      </div>
      <div className="navbar-links">
        <select
          value={i18n.language.startsWith('en') ? 'en' : 'fr'}
          onChange={(e) => void i18n.changeLanguage(e.target.value)}
          aria-label="language"
        >
          <option value="fr">Français</option>
          <option value="en">English</option>
        </select>
        <span className="badge">{user?.email}</span>
        <button className="btn" onClick={handleLogout}>
          {t('nav.logout')}
        </button>
      </div>
    </header>
  );
}
